import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {MultiAppsComponent} from './multi-apps.component';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {MultiAppsRoutingModule} from "./multi-apps-routing.module";
import {CardModule} from "primeng/card";
import {FieldsetModule} from "primeng/fieldset";
import {DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {CalendarModule} from "primeng/calendar";
import {CheckboxModule} from "primeng/checkbox";
import {TableModule} from "primeng/table";
import {SelectButtonModule} from "primeng/selectbutton";
import {RippleModule} from "primeng/ripple";
import {TagModule} from "primeng/tag";
import {DialogModule} from "primeng/dialog";
import {DividerModule} from "primeng/divider";
import {ImageModule} from "primeng/image";
import {SliderModule} from "primeng/slider";
import {InputMaskModule} from "primeng/inputmask";
import {ChipModule} from "primeng/chip";
import {TooltipModule} from "primeng/tooltip";
import {ColorPickerModule} from "primeng/colorpicker";
import {DragToSelectModule} from "ngx-drag-to-select";
import {ToolbarModule} from "primeng/toolbar";
import {SpeedDialModule} from "primeng/speeddial";
import {InputSwitchModule} from "primeng/inputswitch";
import {ToastModule} from "primeng/toast";
import {ImageCropperModule} from "ngx-image-cropper";
import {SkeletonModule} from "primeng/skeleton";
import {BlockUIModule} from "primeng/blockui";
import {BadgeModule} from "primeng/badge";
import {PaginatorModule} from "primeng/paginator";
import {MultiSelectModule} from "primeng/multiselect";
import {GalleriaModule} from "primeng/galleria";
import {CarouselModule} from "primeng/carousel";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {AccordionModule} from "primeng/accordion";
import {ThemeModule} from "../../theme/theme.module";
import {RadioButtonModule} from "primeng/radiobutton";
import {AvatarModule} from "primeng/avatar";


const PRIMENG_MODULES = [
  FieldsetModule,
  CardModule,
  DropdownModule,
  FormsModule,
  InputTextModule,
  CalendarModule,
  CheckboxModule,
  TableModule,
  SelectButtonModule,
  RippleModule,
  TagModule,
  DialogModule,
  DividerModule,
  ImageModule,
  SliderModule,
  InputMaskModule,
  ChipModule,
  TooltipModule,
  ColorPickerModule,
  DragToSelectModule,
  NgOptimizedImage,
  ToolbarModule,
  SpeedDialModule,
  InputSwitchModule,
  ToastModule,
  ImageCropperModule,
  SkeletonModule,
  BlockUIModule,
  ProgressSpinnerModule,
  BadgeModule,
  PaginatorModule,
  MultiSelectModule,
  GalleriaModule,
  CarouselModule,
  OverlayPanelModule,
  ConfirmDialogModule,
  AccordionModule,
  ThemeModule,
  RadioButtonModule,
]

@NgModule({
  declarations: [
    MultiAppsComponent
  ],
  imports: [
    CommonModule,
    ...PRIMENG_MODULES,
    MultiAppsRoutingModule,
    AvatarModule,
  ],
  exports:[
    MultiAppsComponent
  ]
})
export class MultiAppsModule { }
